import { Box } from '@chakra-ui/react';

import BankAccountIcon, {
  BankAccountIllustrationName,
} from '../BankAccountIcon';

const SIZES = {
  big: {
    border: 2,
    component: 'sm',
    container: 40,
    icon: 30,
    offset: 10,
  },
  normal: {
    border: 1,
    component: 'xs',
    container: 30,
    icon: 24,
    offset: 6,
  },
} as const;

interface BankAccountBoxIconProps {
  illustrationName?: BankAccountIllustrationName;
  sizes: (typeof SIZES)['big'] | (typeof SIZES)['normal'];
  onTop?: boolean;
  boxShadow?: boolean;
}

interface StackedBankAccountIconsProps {
  topIllustrationName?: BankAccountIllustrationName;
  bottomIllustrationName?: BankAccountIllustrationName;
  size?: keyof typeof SIZES;
  inverted?: boolean;
}

const BankAccountBoxIcon = ({
  boxShadow,
  illustrationName,
  onTop,
  sizes,
}: BankAccountBoxIconProps) => (
  <Box
    {...(illustrationName
      ? {}
      : { backgroundColor: 'grey.200', borderRadius: 'radius-8' })}
    height={sizes.icon}
    left={onTop ? 0 : sizes.offset}
    position="absolute"
    top={onTop ? 0 : sizes.offset}
    width={sizes.icon}
  >
    {illustrationName ? (
      <BankAccountIcon
        boxShadow={boxShadow ? `0 0 0 ${sizes.border}px white` : undefined}
        illustrationName={illustrationName}
        size={sizes.component}
      />
    ) : null}
  </Box>
);

export const StackedBankAccountIcons = ({
  bottomIllustrationName,
  inverted = false,
  size = 'normal',
  topIllustrationName = 'wallet',
}: StackedBankAccountIconsProps) => {
  const sizes = SIZES[size];

  if (inverted) {
    return (
      <Box height={sizes.container} position="relative" width={sizes.container}>
        <BankAccountBoxIcon
          illustrationName={topIllustrationName}
          onTop
          sizes={sizes}
        />
        <BankAccountBoxIcon
          boxShadow
          illustrationName={bottomIllustrationName}
          sizes={sizes}
        />
      </Box>
    );
  }

  return (
    <Box height={sizes.container} position="relative" width={sizes.container}>
      <BankAccountBoxIcon
        illustrationName={bottomIllustrationName}
        sizes={sizes}
      />
      <BankAccountBoxIcon
        boxShadow
        illustrationName={topIllustrationName}
        onTop
        sizes={sizes}
      />
    </Box>
  );
};
